import { cloneElement } from '../_util/vnode';
import Avatar from './Avatar';
import Popover from '../popover';
import { computed, defineComponent, watchEffect } from 'vue';
import { flattenChildren, getPropsSlot } from '../_util/props-util';
import useConfigInject from '../config-provider/hooks/useConfigInject';
import useStyle from './style';
import { useAvatarProviderContext } from './AvatarContext';
import { objectType } from '../_util/type';
export const groupProps = () => ({
    prefixCls: String,
    /** @deprecated Please use `max={{ count: number }}` */
    maxCount: Number,
    /** @deprecated Please use `max={{ style: CSSProperties }}` */
    maxStyle: { type: Object, default: undefined },
    /** @deprecated Please use `max={{ popover: PopoverProps }}` */
    maxPopoverPlacement: { type: String, default: 'top' },
    /** @deprecated Please use `max={{ popover: PopoverProps }}` */
    maxPopoverTrigger: String,
    /** Max display config (antd ≥ 5.18). */
    max: objectType(),
    /*
     * Size of avatar, options: `large`, `small`, `default`
     * or a custom number size
     * */
    size: {
        type: [Number, String, Object],
        default: 'default',
    },
    shape: { type: String, default: 'circle' },
});
const Group = defineComponent({
    compatConfig: { MODE: 3 },
    name: 'AAvatarGroup',
    inheritAttrs: false,
    props: groupProps(),
    setup(props, { slots, attrs }) {
        const { prefixCls, direction } = useConfigInject('avatar', props);
        const groupPrefixCls = computed(() => `${prefixCls.value}-group`);
        const [wrapSSR, hashId] = useStyle(prefixCls);
        watchEffect(() => {
            const context = { size: props.size, shape: props.shape };
            useAvatarProviderContext(context);
        });
        return () => {
            var _a, _b, _c, _d, _e, _f, _g;
            const { maxCount, maxStyle, maxPopoverPlacement = 'top', maxPopoverTrigger = 'hover', shape, max, } = props;
            const cls = {
                [groupPrefixCls.value]: true,
                [`${groupPrefixCls.value}-rtl`]: direction.value === 'rtl',
                [`${attrs.class}`]: !!attrs.class,
                [hashId.value]: true,
            };
            const children = getPropsSlot(slots, props);
            const childrenWithProps = flattenChildren(children).map((child, index) => cloneElement(child, {
                key: `avatar-key-${index}`,
            }));
            const mergeCount = (_a = max === null || max === void 0 ? void 0 : max.count) !== null && _a !== void 0 ? _a : maxCount;
            const numOfChildren = childrenWithProps.length;
            if (mergeCount && mergeCount < numOfChildren) {
                const childrenShow = childrenWithProps.slice(0, mergeCount);
                const childrenHidden = childrenWithProps.slice(mergeCount, numOfChildren);
                const mergeStyle = (_b = max === null || max === void 0 ? void 0 : max.style) !== null && _b !== void 0 ? _b : maxStyle;
                const mergePopoverTrigger = (_d = (_c = max === null || max === void 0 ? void 0 : max.popover) === null || _c === void 0 ? void 0 : _c.trigger) !== null && _d !== void 0 ? _d : maxPopoverTrigger;
                const mergePopoverPlacement = (_f = (_e = max === null || max === void 0 ? void 0 : max.popover) === null || _e === void 0 ? void 0 : _e.placement) !== null && _f !== void 0 ? _f : maxPopoverPlacement;
                childrenShow.push(<Popover key="avatar-popover-key" content={childrenHidden} {...((max === null || max === void 0 ? void 0 : max.popover) || {})} trigger={mergePopoverTrigger} placement={mergePopoverPlacement} overlayClassName={[`${groupPrefixCls.value}-popover`, (_g = max === null || max === void 0 ? void 0 : max.popover) === null || _g === void 0 ? void 0 : _g.overlayClassName]
                        .filter(Boolean)
                        .join(' ')}>
            <Avatar style={mergeStyle} shape={shape}>{`+${numOfChildren - mergeCount}`}</Avatar>
          </Popover>);
                return wrapSSR(<div {...attrs} class={cls} style={attrs.style}>
            {childrenShow}
          </div>);
            }
            return wrapSSR(<div {...attrs} class={cls} style={attrs.style}>
          {childrenWithProps}
        </div>);
        };
    },
});
export default Group;
